import { render, staticRenderFns } from "./ViewModel.vue?vue&type=template&id=46e977b5&"
import script from "./ViewModel.vue?vue&type=script&lang=js&"
export * from "./ViewModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports